import { isArray } from 'util';
import { mapCollection } from '../../utils/collection.utils';
import { parseNumber } from '../../utils/number.utils';
import { SaleOfferPreparation } from '../sale-offer-preparation';

export class SaleOfferPreparationBuilder {
  static fromJson(json): SaleOfferPreparation {
    return (json) ? new SaleOfferPreparation(
      json.hash,
      parseNumber(json.preparationDate),
      json.observations
    ) : null;
  }

  static fromJsonList(list): SaleOfferPreparation[] {
    return (isArray(list)) ? mapCollection(SaleOfferPreparationBuilder.fromJson, list) : [];
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/models/builders/sale-offer-preparation-builder.ts